export default __webpack_public_path__ + "static/media/gardening.1425504e.jpg";